import { z } from "zod";

import { imageSchema } from "./image";
import { richTextSchema } from "./rich-text";

export const memberSchema = z.object({
  type: z.literal("teamMember"),
  name: z.string(),
  spotlight: z.string().optional(),
  position: z.string().nullable(),
  image: imageSchema.nullable(),
  intro: richTextSchema.nullable(),
  description: richTextSchema,
  linkedinUrl: z.string().nullable(),
});
